// 公用框架代码
const sys = window.system || window
const version = require('../package.json').version
//all features
let arrKeys = [
  'app.getInfo', 'app.exit', 'app.query',
  'device.getUserId',
  'device.getInfo'
  //'ringtone.playTone'
]
//存储正常promise返回函数
let hashResolve = Object.create(null)
function uuid() {
  return (
    +new Date() +
    '-' +
    Math.random()
      .toString(32)
      .substr(2)
  )
}
function getPromise(str) {
  return function () {
    let params = arguments
    let uid = ''
    let myPromise = new Promise((resolve, reject) => {
      uid = uuid()
      sys.postMessage(JSON.stringify({ uid, name: str, params }))
      hashResolve[uid] = { resolve, reject }
    })
    return myPromise
  }
}

//接收快应用发向h5的message
sys.onmessage = function () {
  let args = arguments
  let res = null
  if (typeof args[0] === 'object') {
    res = args[0]
  } else {
    res = JSON.parse(args[0])
  }
  let { uid, type } = res
  delete res.uid
  delete res.type
  if (res.name === 'backpress.click') {
    //点击按钮返回，此处处理,此处广播时间
    // let evt = new Event('backpress')
    // window.dispatchEvent(evt)
    let keyCodeEvtDown = new Event('keydown');
    let keyCodeEvtUp = new Event('keyup');
    let keyCodeEvtPress = new Event('keypress');
    keyCodeEvtDown.keyCode = 166;
    keyCodeEvtUp.keyCode = 166;
    keyCodeEvtPress.keyCode = 166;
    let target = document.querySelector(":focus")
    let targets =  [document,window]
    if(target){
      targets.push(target)
    }
    targets.forEach(tar=>{
      tar.dispatchEvent(keyCodeEvtDown)
      tar.dispatchEvent(keyCodeEvtUp)
      tar.dispatchEvent(keyCodeEvtPress)
    })
  }
  if (uid) {
    hashResolve[uid] && hashResolve[uid].resolve(res)
    delete hashResolve[uid]
  }
}

let jssdk = Object.create(null)
arrKeys.forEach(str => {
  let [root, name] = str.split('.')
  if (!jssdk[root]) {
    jssdk[root] = Object.create(null)
  }
  jssdk[root][name] = getPromise(str)
})
const {app,device} = jssdk;
export { app ,device ,version}

